import * as types from './actions';

export const initialState = {
  cars: {},
  pageControl: {
    menu: '',
    subMenu: '',
    page: '',
    actionPage: ''
  },
  pagesData: {
    addCar: {
      step: 0,
      data: {
        vdp_url: '',
        heading: '',
        price: '',
        miles: '',
        interior_color: '',
        exterior_color: '',
        base_ext_color: '',
        base_int_color: '',
        build: {
          model: '',
          year: '',
          body_type: '',
          make: '',
          trim: '',
          transmission: '',
          fuel_type: '',
          doors: 5,
          std_seating: 5
        },
        media: {
          photo_links: []
        }
      }
    },
    carData: {
      _id: '',
      listings: {
        vdp_url: '',
        heading: '',
        price: '',
        miles: '',
        interior_color: '',
        exterior_color: '',
        base_ext_color: '',
        base_int_color: '',
        build: {
          model: '',
          year: '',
          body_type: '',
          make: '',
          trim: '',
          transmission: '',
          fuel_type: '',
          doors: 5,
          std_seating: 5
        },
        media: {
          photo_links: []
        }
      }
    }
  }
};

export default function(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case types.LOAD_CAR_LIST:
      return { ...state, cars: payload };

    case types.ADD_IMG_CAR_DATA:
      return {
        ...state,
        pagesData: {
          ...state.pagesData,
          addCar: {
            ...state.pagesData.addCar,
            data: {
              ...state.pagesData.addCar.data,
              media: {
                ...state.pagesData.addCar.data.media,
                photo_links: [...state.pagesData.addCar.data.media.photo_links, payload]
              },
              vdp_url: state.pagesData.addCar.data.media.photo_links[0] ?
                state.pagesData.addCar.data.media.photo_links[0] : payload
            }
          }
        }
      };
    case types.EDIT_ADD_IMG_CAR_DATA:
      return {
        ...state,
        pagesData: {
          ...state.pagesData,
          carData: {
            ...state.pagesData.carData,
            listings: {
              ...state.pagesData.carData.listings,
              media: {
                ...state.pagesData.carData.listings.media,
                photo_links: [...state.pagesData.carData.listings.media.photo_links, payload]
              },
              vdp_url: state.pagesData.carData.listings.media.photo_links[0] ?
                state.pagesData.carData.listings.media.photo_links[0] : payload
            }
          }
        }
      };

    case types.DEL_IMG_CAR_DATA:
      return {
        ...state,
        pagesData: {
          ...state.pagesData,
          addCar: {
            ...state.pagesData.addCar,
            data: {
              ...state.pagesData.addCar.data,
              media: {
                ...state.pagesData.addCar.data.media,
                photo_links:
                state.pagesData.addCar.data.media.photo_links.filter(element => element !== payload)
              },
              vdp_url:
state.pagesData.addCar.data.media.photo_links.filter(element => element !== payload).length > 0
  ? state.pagesData.addCar.data.media.photo_links.filter(element =>
    element !== payload)[0] : ''
            }
          }
        }
      };

    case types.EDIT_DEL_IMG_CAR_DATA:
      return {
        ...state,
        pagesData: {
          ...state.pagesData,
          carData: {
            ...state.pagesData.carData,
            listings: {
              ...state.pagesData.carData.listings,
              media: {
                ...state.pagesData.carData.listings.media,
                photo_links:
          state.pagesData.carData.listings.media.photo_links.filter(element => element !== payload)
              },
              vdp_url:
state.pagesData.carData.listings.media.photo_links.filter(element => element !== payload).length > 0
  ? state.pagesData.carData.listings.media.photo_links.filter(element =>
    element !== payload)[0] : ''
            }
          }
        }
      };

    case types.SET_ACTION_PAGE:
      return {
        ...state,
        pageControl: {
          ...state.pageControl, actionPage: payload
        }
      };

    case types.SET_MENU_PAGE:
      return {
        ...state,
        pageControl: {
          ...state.pageControl, menu: payload
        }
      };

    case types.SET_SUB_MENU_PAGE:
      return {
        ...state,
        pageControl: {
          ...state.pageControl, subMenu: payload
        }
      };

    case types.ADD_CAR_DATA_PAGE:
      return {
        ...state,
        pagesData: {
          ...state.pagesData,
          addCar: {
            ...state.pagesData.addCar,
            step: payload
          }
        }
      };

    case types.LOAD_CAR_DARA_TO_CARDATAPAGE:
      return {
        ...state,
        pagesData: {
          ...state.pagesData,
          carData: payload
        }
      };

    case types.ADD_CAR_CHANGE_DATA:
      return {
        ...state,
        pagesData: {
          ...state.pagesData,
          addCar: {
            ...state.pagesData.addCar,
            data: payload
          }
        }
      };

    case 'RESET_STORE':
      return {
        ...state,
        ...initialState
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/pages/CarEditorPage/reducer.js